module.exports = __webpack_public_path__ + "img/module-bg.e3dd9ec2.jpg";